var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import KanbanBoard from '@/modules/tasks/taskboard/kanban/KanbanBoard';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';
import MainTask from './MainTask';
var OpenTask = function (_a) {
    var task = _a.task, retrieveRemark = _a.retrieveRemark, remark = _a.remark, loadingRemark = _a.loadingRemark;
    var setShowModalInfo = useModalContext().setShowModalInfo;
    var shareItem = function (t) {
        setShowModalInfo({ modalType: ModalType.Share, task: __assign(__assign({}, t), { relation: task.relation }) });
    };
    return (_jsxs(_Fragment, { children: [_jsx("td", __assign({ className: "dskb-cell dskb-header dskb-row-header dskb-group-container" }, { children: _jsx("div", __assign({ className: "dskb-content-box" }, { children: _jsx(MainTask, { task: task, shareItem: shareItem, openTaskDetails: function () {
                            setShowModalInfo({ modalType: ModalType.TaskDetail, task: task });
                        }, retrieveRemark: retrieveRemark, remark: remark, loadingRemark: loadingRemark }) })) })), _jsx(KanbanBoard, { task: task, shareItem: shareItem }, task.id)] }));
};
export default OpenTask;
